import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { H2 } from "storybook-components/Typography";
import ErrorBoundary from "./ErrorBoundary";

const StyledH2 = styled(H2)`
  color: ${({ theme }) => theme.colors.green5};
  margin-top: 32px;
  margin-bottom: 40px;
`;

const HelpContent = ({ htmlAst, title }) => {
  return (
    <>
      <Helmet>
        <script
          type="text/javascript"
          src="https://app.mode.com/embed/embed.js"
        />
      </Helmet>
      <StyledH2
        // className for Algolia Docsearch https://github.com/algolia/docsearch-configs/blob/master/configs/modeanalytics.json
        className="article-header"
      >
        {title}
      </StyledH2>
      <ErrorBoundary>
        <div
          // className for Algolia Docsearch https://github.com/algolia/docsearch-configs/blob/master/configs/modeanalytics.json
          className="article-container"
        >
          {htmlAst}
        </div>
      </ErrorBoundary>
    </>
  );
};

export default HelpContent;
